module.exports = __webpack_public_path__ + "static/img/cc.91b7acfa.svg";